import React, { useState, useMemo, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import CompanySales from "../../ViewDetail/RetailerDash/CompanySales";
import { Eye, EyeOff, Tag } from "lucide-react";
import { BASE_URL } from "../../../config/api";
import toast from "react-hot-toast";
import axios from "axios";

function RetailerDashboard() {
  const navigate = useNavigate();

  const [currentView, setCurrentView] = useState("dashboard"); // dashboard | warranty | invoices | documents | ledger | users
  const [warrantyFilter, setWarrantyFilter] = useState("all");
  const [walletRefresh, setWalletRefresh] = useState(false);

  const [banners, setBanners] = useState([]);
  const [bannerLoading, setBannerLoading] = useState(true);
  const [showBalance, setShowBalance] = useState(false);
  
  // Example balance (replace with real value)
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [walletLoading, setWalletLoading] = useState(false);

  const [addWalletModal, setAddWalletModal] = useState(false);
const [walletAmount, setWalletAmount] = useState("");

const [paymentKeys, setPaymentKeys] = useState({
    key_id: "",
    key_secret: ""
  });

  const [keyLoading, setKeyLoading] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [paymentSaving, setPaymentSaving] = useState(false);

  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);

  const [allowWallet, setAllowWallet] = useState(null);
const [walletPermissionLoading, setWalletPermissionLoading] = useState(true);

  const authUserString = localStorage.getItem("authUserData");
  const authUser = JSON.parse(authUserString);
  const loginUserID = authUser?.id;
  const companyId = authUser?.company_id;
  const LoginUserName = authUser?.business_name;
  const loginUserCode = authUser?.org_code;
  const zohoId = authUser?.zoho_id;
  const userRole = authUser?.role;


  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const [isMobile, setIsMobile] = useState(
    (userRole === 5 || userRole === 6) && window.innerWidth < 640
  );

useEffect(() => {
  const handleResize = () => {
    setIsMobile((userRole === 5 || userRole === 6) && window.innerWidth < 640);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, [userRole]);


  const fetchBanners = async () => {

    try {

      const response =
        await axios.get(
          `${BASE_URL}warranty/get-banner`,
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const data =
        response.data;

      if (data?.status) {

        setBanners(
          data?.data?.data || []
        );
      }

    } catch (error) {

      console.error(
        "Banner fetch error:",
        error
      );

    } finally {

      setBannerLoading(false);

    }
  };

  useEffect(() => {

    fetchBanners();

  }, []);

  const fetchPaymentKeys = async () => {

    try {

      setKeyLoading(true);

      const response =
        await axios.get(
          `${BASE_URL}payment/keys`,
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const data =
        response.data;

      if (
        Array.isArray(data) &&
        data.length > 0
      ) {

        setPaymentKeys({
          key_id:
            data[0].key_id,

          key_secret:
            data[0].key_secret,
        });

      } else {

        console.error(
          "Invalid keys response",
          data
        );
      }

    } catch (err) {

      console.error(
        "Failed to fetch payment keys",
        err
      );

    } finally {

      setKeyLoading(false);

    }
  };

  useEffect(() => {
      fetchPaymentKeys();
  }, []);



const notesData = {
  role: authUser?.role,
  service: "advance_payment",
  user_code: authUser?.company_code,
  user_id: authUser?.id,
  retailer_id: authUser?.id,
  name: authUser?.business_name,
  company_id: authUser?.company_id,
  zoho_id: authUser?.zoho_id || null,
  invoice_id: null,
};


const handlePayment = (amount, onSuccess) => {
  if (!amount) return;

  if (!paymentKeys.key_id) {
    alert("Payment keys not loaded!");
    return;
  }

  if (Number(amount) < 1000) {
    toast.error("Minimum amount is ₹1000");
    return;
  }

  const options = {
    key: paymentKeys.key_id,
    amount: amount * 100,
    currency: "INR",
    name: "Warranty Mitra",
    notes: notesData,

    handler: async function (response) {
      setPaymentCompleted(true);
      setPaymentSaving(true);

      const payload = {
        company_id: authUser?.company_id,
        user_id: authUser?.id,
        payment_id: response.razorpay_payment_id,
        amount: amount,
        status: response,
        payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        customer_id: zohoId || null,
        payment_from: "WARRANTY",
        role: authUser?.role,
        w_type:"advance_payment",
      };

      try {

        const response =
          await axios.post(
            `${BASE_URL}zoho/create-online-payment`,
            payload,
            {
              headers: {
                Accept:
                  "application/json",

                "Content-Type":
                  "application/json",
              },
            }
          );

        const data =
          response.data;

        toast.success(
          "Payment Successful & Saved in Zoho 🎉"
        );

        // fetchWalletBalance();
        setWalletRefresh(
          (prev) => !prev
        );

        setAddWalletModal(
          false
        );

        setWalletAmount("");

        // 👇 close popup from child (desktop)
        if (onSuccess) {
          onSuccess();
        }

      } catch (err) {

        console.error(err);

        toast.error(
          err?.response?.data
            ?.message ||
          "Payment succeeded but failed to update Zoho!"
        );

      } finally {

        setPaymentSaving(
          false
        );
      }
    },

    prefill: {
      name: authUser?.name || "",
      email: authUser?.contact_email || "",
      contact: authUser?.contact_phone || "",

    },

    theme: { color: "#2563eb" },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};

useEffect(() => {

  const fetchUserDetails = async () => {
    try {
      setWalletPermissionLoading(
        true
      );
   
      const response =
        await axios.get(
          `${BASE_URL}common/get-users`,
          {
            params: {
              id: loginUserID,
            },

            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const data =
        response.data;

      if (
        data?.status &&
        data?.data?.length > 0
      ) {

        const userData =
          data.data[0];

        setAllowWallet(
          userData.allow_wallet
        );
      }

    } catch (err) {

      console.error(
        "Failed to fetch user details:",
        err
      );

    } finally {

      setWalletPermissionLoading(
        false
      );

    }
  };

  fetchUserDetails();

}, [loginUserID]);

const shouldShowWallet =
  userRole !== 6 || (userRole === 6 && allowWallet !== null);


  const filteredItems = [
  { label: "Warranties", icon: "🛡️", path: "/retwarnty" },
  { label: "Invoices", icon: "📄", path: "/retinv" },
  { label: "Customers", icon: "👥", path: "/customerlist" },
  { label: "Promoters", icon: "🧑‍💼", path: "/retuser" }
  ].filter((item) => {
    if (
      userRole === 6 &&
      (item.label === "Invoices" || item.label === "Promoters")
    ) {
      return false;
    }
    return true;
  });

return (
  <>
    {isMobile ? (
    // <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-slate-100 p-4 space-y-6">
      <div className="min-h-screen bg-gradient-to-br from-slate-300 via-blue-200 to-slate-500 p-2 space-y-4"> 
      
      {/* ====== GREETING ====== */}
      {/* <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-slate-500">Hello 👋</p>
          <h2 className="text-xl font-bold text-slate-800">
            {LoginUserName}
          </h2>
        </div>

        <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
          🏪
        </div>
      </div> */}

      {/* ====== PROMO BANNER ====== */}
      {!walletPermissionLoading && shouldShowWallet && (
      <div 
      onClick={() => navigate("/retailer-transactions")}
      className="rounded-3xl p-3 bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-lg flex justify-between items-center">

        <div>
          <p className="text-lg opacity-90 font-medium">Wallet Balance</p>

          <div className="mt-1">
            <div className="bg-white/20 backdrop-blur-xl border border-white/30 px-3 py-1 rounded-2xl">

              <div className="flex items-center gap-3">
                <p className="text-lg font-bold tracking-wide">
                  {showBalance
                    ? `₹${balanceAmount.toLocaleString("en-IN")}`
                    : "••••••"}
                </p>

                <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowBalance(!showBalance);
                    }}
                  >
                    {showBalance ? (
                      <EyeOff className="w-4 h-4 text-white" />
                    ) : (
                      <Eye className="w-4 h-4 text-white" />
                    )}
                  </button>
              </div>

            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        
          <div className="flex flex-col items-end gap-2">
          {userRole === 5 && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              setAddWalletModal(true);
            }}
            className="bg-white text-indigo-600 text-xs font-semibold px-3 py-1.5 rounded-xl shadow hover:scale-105 transition"
          >
            Add Money
          </button>
          )}
          <div className="text-4xl opacity-30">💰</div>
        </div>
        
      </div>
      )}
      {/* ====== DYNAMIC BANNER ====== */}

      {bannerLoading ? (
        <div className="relative rounded-3xl overflow-hidden shadow-lg 
                border border-white/30 
                backdrop-blur-2xl 
                bg-gradient-to-br from-white/40 to-white/20">
          
          {/* Shimmer layer */}
          <div className="absolute inset-0 bg-gradient-to-r 
                          from-white/10 via-white/40 to-white/10 
                          animate-[shimmer_1.8s_infinite] 
                          bg-[length:200%_100%]" />
          
          {/* Fake content block */}
          <div className="h-40 w-full" />
        </div>
      ) : banners.length > 0 ? (
        <div className="relative rounded-3xl overflow-hidden shadow-lg">
          {/* <a
            href={banners[0]?.link}
            target="_blank"
            rel="noopener noreferrer"
          > */}
            <img
              src={banners[0]?.image}
              alt={banners[0]?.title}
              className="w-full h-[200px] object-cover"
            />
          {/* </a> */}
        </div>
      ) : null}

      {/* ====== QUICK ACTION GRID ====== */}
      <div>
        <h3 className="font-semibold text-slate-700 mb-3">
          Quick Actions
        </h3>

        {/* <div className="grid grid-cols-4 gap-4">
          {[
            { label: "Add", icon: "➕", path: "/customer-create" },
            { label: "Warranties", icon: "🛡️", path: "/retwarnty" },
            { label: "Invoices", icon: "📄", path: "/retinv" },
            { label: "Customers", icon: "👥", path: "/customerlist" },
          ].map((item, i) => (
            <div
              key={i}
              onClick={() => navigate(item.path)}
              className="bg-white/10 backdrop-blur-2xl 
                border border-white/30 
                rounded-2xl p-4 cursor-pointer
                flex flex-col items-center justify-center gap-2
                transition-all duration-300
                shadow-[0_20px_50px_rgba(31,38,135,0.25),0_8px_20px_rgba(0,0,0,0.15),inset_0_1px_1px_rgba(255,255,255,0.35)]
                hover:scale-105 hover:shadow-[0_30px_70px_rgba(31,38,135,0.35),0_12px_30px_rgba(0,0,0,0.2),inset_0_1px_1px_rgba(255,255,255,0.4)]"
            >
              <div className="relative w-10 h-10 flex items-center justify-center 
                rounded-xl
                bg-white/10 backdrop-blur-2xl 
                border border-white/30
                shadow-[0_10px_25px_rgba(31,38,135,0.22),0_4px_10px_rgba(0,0,0,0.12),inset_0_1px_1px_rgba(255,255,255,0.35)]">

                <span className="text-lg">{item.icon}</span>
              </div>

              <p className="text-xs text-slate-800 text-center">
                {item.label}
              </p>
            </div>
          ))}
        </div> */}

      <div
        className={`grid gap-4 ${
          filteredItems.length === 2
            ? "grid-cols-2"
            : filteredItems.length === 3
            ? "grid-cols-3"
            : "grid-cols-4"
        }`}
      >
        {filteredItems.map((item, i) => {
          const isAdd = item.label === "Add";
          const IconComponent = item.icon;

          return (
            <div
              key={i}
              onClick={() => navigate(item.path)}
              className={`rounded-2xl p-4 cursor-pointer
                flex flex-col items-center justify-center gap-2
                transition-all duration-300
                ${
                  isAdd
                    ? "bg-gradient-to-br from-blue-600/80 to-indigo-700/80 text-white shadow-lg hover:shadow-xl hover:scale-105"
                    : "bg-white/10 backdrop-blur-2xl border border-white/30 text-slate-800 shadow-[0_20px_50px_rgba(31,38,135,0.25),0_8px_20px_rgba(0,0,0,0.15),inset_0_1px_1px_rgba(255,255,255,0.35)] hover:scale-105"
                }`}
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-xl
                  ${
                    isAdd
                      ? "bg-white/20"
                      : "bg-white/10 backdrop-blur-2xl border border-white/30"
                  }`}
              >
                {typeof IconComponent === "string" ? (
                  <span className="text-lg">{IconComponent}</span>
                ) : (
                  <IconComponent className="w-5 h-5" />
                )}
              </div>

              <p
                className={`text-xs text-center font-medium ${
                  isAdd ? "text-white" : "text-slate-800"
                }`}
              >
                {item.label}
              </p>
            </div>
          );
        })}
      </div>
      </div>

      {/* ====== KPI SECTION ====== */}
      <CompanySales
        fromUserView={false}
        walletRefresh={walletRefresh}
        balanceAmount={balanceAmount}
        walletLoading={walletLoading}
        handlePayment={handlePayment}
        setBalanceAmount={setBalanceAmount}   // 👈 ADD THIS
        setWalletLoading={setWalletLoading}
        walletPermissionLoading={walletPermissionLoading}
        shouldShowWallet={shouldShowWallet}
      />

      {addWalletModal && (
        <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-black/40 backdrop-blur-sm">

          <div className="absolute bottom-0 w-full max-w-md rounded-t-3xl glass-small-card bg-white/10 backdrop-blur-2xl border border-white/20 p-6 min-h-[260px] animate-slideUp">

            {/* Handle */}
            <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-4"></div>

            <h2 className="text-lg font-semibold text-center mb-4 text-white">
              Add Money
            </h2>

            {/* Amount Input */}
            <input
              type="number"
              min="1000"
              placeholder="Enter Amount (₹)"
              value={walletAmount}
              className="w-full border rounded-xl px-4 py-3 mb-4 focus:ring-2 focus:ring-blue-500 outline-none bg-slate-700 text-white"
              onChange={(e) => {
                const value = e.target.value;
                if (value < 1000) {
                  setWalletAmount(value); // allow typing but validate later
                } else {
                  setWalletAmount(value);
                }
              }}
            />

            {/* Quick Amount Buttons */}
            <div className="flex gap-2 justify-between mb-6">
              {[1000, 3000, 5000].map((amt) => (
                <button
                  key={amt}
                  onClick={() => setWalletAmount(String(amt))}
                  className="flex-1 border rounded-xl py-2 text-sm font-semibold text-white hover:bg-blue-700"
                >
                  ₹{amt}
                </button>
              ))}
            </div>

            {/* Add Balance Button */}
            <button
              onClick={() => handlePayment(walletAmount)}
              className="w-full bg-blue-400 text-white py-3 rounded-xl font-semibold hover:bg-blue-700 transition"
            >
              Add Balance
            </button>

            {/* Cancel */}
            <button
              onClick={() => setAddWalletModal(false)}
              className="w-full mt-3 text-gray-300 text-sm"
            >
              Cancel
            </button>

          </div>
        </div>
      )}

      {paymentSaving && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/20 backdrop-blur-sm">

          <div className="bg-white/10 backdrop-blur-xl rounded-2xl px-8 py-6 shadow-xl flex flex-col items-center gap-4">

            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

            <p className="text-sm font-semibold text-slate-400">
              Finalizing Payment...
            </p>

          </div>

        </div>
      )}
    </div>

) : (

  <div className="flex-1 flex flex-col">
    <main className="flex-1 space-y-4">
      <CompanySales
        fromUserView={false}
        walletRefresh={walletRefresh}
        walletLoading={walletLoading}
        handlePayment={handlePayment}
        balanceAmount={balanceAmount}
        setBalanceAmount={setBalanceAmount}   // 👈 ADD THIS
        setWalletLoading={setWalletLoading}
        walletPermissionLoading={walletPermissionLoading}
        shouldShowWallet={shouldShowWallet}
      />
    </main>
  </div>
    )}
  </>
)
}

export default RetailerDashboard;



// **********************************************mobile view*************************************************************88

// import React, { useState, useMemo } from "react";

// import { useNavigate } from "react-router-dom";
// import CompanySales from "../../ViewDetail/RetailerDash/CompanySales";

// function RetailerDashboard() {
//   const navigate = useNavigate();

//   const [currentView, setCurrentView] = useState("dashboard"); // dashboard | warranty | invoices | documents | ledger | users
//   const [warrantyFilter, setWarrantyFilter] = useState("all");

//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   const LoginUserName = authUser?.business_name;
//   const loginUserCode = authUser?.org_code;

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/login");
//   };

//   return (
//   <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-slate-100 p-4 space-y-6">

//     {/* ====== GREETING ====== */}
//     <div className="flex items-center justify-between">
//       <div>
//         <p className="text-sm text-slate-500">Hello 👋</p>
//         <h2 className="text-xl font-bold text-slate-800">
//           {LoginUserName}
//         </h2>
//       </div>

//       <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
//         🏪
//       </div>
//     </div>

//     {/* ====== SEARCH BAR ====== */}
//     {/* <div className="
//       bg-white/40 backdrop-blur-xl
//       border border-white/40
//       rounded-2xl px-4 py-3
//       shadow-sm
//     ">
//       <input
//         placeholder="Search invoices, warranties..."
//         className="w-full bg-transparent outline-none text-sm"
//       />
//     </div> */}

//     {/* ====== PROMO BANNER ====== */}
//     <div className="
//       rounded-3xl p-5
//       bg-gradient-to-br from-blue-500 to-indigo-600
//       text-white shadow-lg
//       flex justify-between items-center
//     ">
//       <div>
//         <p className="text-sm opacity-90">This Month</p>
//         <p className="text-2xl font-bold mt-1">
//           {/* ₹{kpis?.revenue?.toLocaleString() || 0} */}
//         </p>
//         <button
//           onClick={() => navigate("/earnings")}
//           className="mt-3 bg-white text-blue-600 px-4 py-1.5 rounded-xl text-sm font-semibold"
//         >
//           View Earnings
//         </button>
//       </div>

//       <div className="text-5xl opacity-30">
//         💰
//       </div>
//     </div>

//     {/* ====== QUICK ACTION GRID ====== */}
//     <div>
//       <div className="flex justify-between items-center mb-3">
//         <h3 className="font-semibold text-slate-700">
//           Quick Actions
//         </h3>
//       </div>

//       <div className="grid grid-cols-4 gap-4">
//         {[
//           { label: "Add", icon: "➕", path: "/customer-create" },
//           { label: "Warranties", icon: "🛡️", path: "/retwarnty" },
//           { label: "Invoices", icon: "📄", path: "/retinv" },
//           { label: "Customers", icon: "👥", path: "/customers" },
//         ].map((item, i) => (
//           <div
//             key={i}
//             onClick={() => navigate(item.path)}
//             className="
//               bg-white/50 backdrop-blur-xl
//               border border-white/40
//               rounded-2xl p-4
//               text-center cursor-pointer
//               hover:scale-105 transition
//             "
//           >
//             <div className="text-2xl">{item.icon}</div>
//             <p className="text-xs mt-2 text-slate-700">
//               {item.label}
//             </p>
//           </div>
//         ))}
//       </div>
//     </div>

//     {/* ====== KPI SECTION ====== */}
//     <CompanySales />

//   </div>
// );
// }

// export default RetailerDashboard;


// **************************************desktop view***********************************************************888

// import React, { useState, useMemo } from "react";

// import { useNavigate } from "react-router-dom";
// import CompanySales from "../../ViewDetail/RetailerDash/CompanySales";

// function RetailerDashboard() {
//   const navigate = useNavigate();

//   const [currentView, setCurrentView] = useState("dashboard"); // dashboard | warranty | invoices | documents | ledger | users
//   const [warrantyFilter, setWarrantyFilter] = useState("all");

//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   const LoginUserName = authUser?.business_name;
//   const loginUserCode = authUser?.org_code;

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/login");
//   };

//   return (
//       <div className="flex-1 flex flex-col">

//         {/* Main Body */}
//         <main className="flex-1 space-y-4">
//           {currentView === "dashboard" && (
//             <>
//             <CompanySales/>
//             </>
//           )}
//         </main>
//       </div>
//   );
// }

// export default RetailerDashboard;




// import React, { useState, useMemo } from "react";

// import {
//   LayoutDashboard,
//   ShieldCheck,
//   FileText,
//   FileSpreadsheet,
//   Scale,
//   Wallet,
//   ReceiptIndianRupee,
//   FileBarChart2,
//   FileDown,
//   ArrowRight,
//   Users as UsersIcon,
//   UserPlus,
// } from "lucide-react";
// import DashboardView from "./DashboardView";
// import WarrantyView from "./WarrantyView";
// import InvoicesView from "./InvoicesView";
// import LedgerView from "./LedgerView";
// import UsersView from "./UsersView";
// import DocumentsView from "./DocumentsView";
// import ProfileDropdown from "../../../Component/Common/ProfileDropdown";
// import { useNavigate } from "react-router-dom";
// import CompanySales from "../../ViewDetail/RetailerDash/CompanySales";

// // -----------------------------------------------------------------------------
// // Mock Data + Manual Test Cases
// // -----------------------------------------------------------------------------
// // Manual test ideas:
// // 1) Default data below – retailer with invoices, warranties, documents, ledger & users.
// // 2) Empty arrays (set all mock arrays to []) – UI should still render without
// //    crashing and show "No data" messages.
// // 3) All warranties approved vs all rejected – check KPI percentages and colors.
// // 4) Ledger with only debit or only credit entries – verify closing balance sign.
// // 5) Large invoice values – verify formatting (₹ & thousands separator).

// const mockSalesAndWarranty = {
//   totalSalesAmount: 350000,
//   totalInvoicesCount: 14,
//   pendingInvoicesCount: 4,
//   uninvoicedAmount: 45000,
//   creditNoteAmount: 8000,
//   totalWarrantySubmitted: 18,
//   totalWarrantyApproved: 12,
//   totalWarrantyRejected: 4,
//   totalWarrantyPending: 2,
//   payableAmount: 120000,
//   paidAmount: 90000,
//   earningsAmount: 30000,
// };

// const warrantyTrend = [
//   { month: "Jun", submitted: 6, approved: 4, rejected: 1 },
//   { month: "Jul", submitted: 8, approved: 6, rejected: 1 },
//   { month: "Aug", submitted: 5, approved: 3, rejected: 1 },
//   { month: "Sep", submitted: 10, approved: 7, rejected: 2 },
//   { month: "Oct", submitted: 12, approved: 9, rejected: 2 },
// ];

// const invoiceTrend = [
//   { month: "Jun", invoiced: 60000, paid: 45000 },
//   { month: "Jul", invoiced: 80000, paid: 60000 },
//   { month: "Aug", invoiced: 70000, paid: 50000 },
//   { month: "Sep", invoiced: 90000, paid: 70000 },
//   { month: "Oct", invoiced: 105000, paid: 85000 },
// ];

// const mockInvoices = [
//   {
//     id: "INV-2025-001",
//     date: "2025-10-02",
//     amount: 25000,
//     status: "Paid", // Paid | Partially Paid | Unpaid
//     paidAmount: 25000,
//     creditNote: 0,
//     dueDate: "2025-10-15",
//   },
//   {
//     id: "INV-2025-002",
//     date: "2025-10-10",
//     amount: 40000,
//     status: "Partially Paid",
//     paidAmount: 25000,
//     creditNote: 5000,
//     dueDate: "2025-10-25",
//   },
//   {
//     id: "INV-2025-003",
//     date: "2025-10-18",
//     amount: 35000,
//     status: "Unpaid",
//     paidAmount: 0,
//     creditNote: 0,
//     dueDate: "2025-11-05",
//   },
//   {
//     id: "INV-2025-004",
//     date: "2025-11-02",
//     amount: 50000,
//     status: "Paid",
//     paidAmount: 50000,
//     creditNote: 3000,
//     dueDate: "2025-11-15",
//   },
// ];

// const mockWarrantyClaims = [
//   {
//     id: "WAR-1001",
//     saleInvoice: "INV-2025-001",
//     productName: "POS Terminal Basic",
//     imei: "356789012345678",
//     purchaseDate: "2025-08-15",
//     claimDate: "2025-10-01",
//     status: "Approved", // admin review status
//     decisionDate: "2025-10-05",
//     reason: "Main board failure",
//     rejectReason: "",
//     approvedAmount: 5000,
//     raisedBy: "Retailer", // Retailer | Customer
//     registeredBy: "Sanjay (Owner)", // which user registered claim
//     settlementStatus: "Settled", // Settled | In Progress | Not started
//   },
//   {
//     id: "WAR-1002",
//     saleInvoice: "INV-2025-002",
//     productName: "mPOS Wireless",
//     imei: "352345678901234",
//     purchaseDate: "2025-09-01",
//     claimDate: "2025-10-12",
//     status: "Rejected",
//     decisionDate: "2025-10-15",
//     reason: "Physical damage",
//     rejectReason: "Liquid damage not covered",
//     approvedAmount: 0,
//     raisedBy: "Customer",
//     registeredBy: "Support Desk",
//     settlementStatus: "Not started",
//   },
//   {
//     id: "WAR-1003",
//     saleInvoice: "INV-2025-003",
//     productName: "Soundbox Pro",
//     imei: "351234567890123",
//     purchaseDate: "2025-09-10",
//     claimDate: "2025-10-25",
//     status: "Pending",
//     decisionDate: "",
//     reason: "Speaker not working",
//     rejectReason: "",
//     approvedAmount: 0,
//     raisedBy: "Retailer",
//     registeredBy: "Sanjay (Owner)",
//     settlementStatus: "In Progress",
//   },
// ];

// // Sold warranty for devices (extended warranty at the time of sale)
// const mockSoldWarranties = [
//   {
//     id: "SWR-2001",
//     saleInvoice: "INV-2025-001",
//     productName: "POS Terminal Basic",
//     warrantyType: "1 Year Extended Warranty",
//     soldOn: "2025-08-15",
//     amount: 1500,
//     status: "Approved", // Approved | Rejected | Pending
//     rejectReason: "",
//     registeredBy: "Sanjay (Owner)",
//   },
//   {
//     id: "SWR-2002",
//     saleInvoice: "INV-2025-002",
//     productName: "mPOS Wireless",
//     warrantyType: "1 Year Extended Warranty",
//     soldOn: "2025-09-05",
//     amount: 2000,
//     status: "Rejected",
//     rejectReason: "Payment not paid",
//     registeredBy: "Billing Desk",
//   },
//   {
//     id: "SWR-2003",
//     saleInvoice: "INV-2025-003",
//     productName: "Soundbox Pro",
//     warrantyType: "6 Month Device Protection",
//     soldOn: "2025-09-20",
//     amount: 1200,
//     status: "Rejected",
//     rejectReason: "Wrong product info",
//     registeredBy: "Billing Desk",
//   },
//   {
//     id: "SWR-2004",
//     saleInvoice: "INV-2025-004",
//     productName: "POS Terminal Basic",
//     warrantyType: "1 Year Extended Warranty",
//     soldOn: "2025-11-02",
//     amount: 1500,
//     status: "Pending",
//     rejectReason: "",
//     registeredBy: "Sanjay (Owner)",
//   },
// ];

// const mockDocuments = {
//   privacyPolicyAccepted: true,
//   termsAccepted: true,
//   agreementSigned: true,
//   paymentTermDays: 15,
//   fetchedDocs: [
//     {
//       id: "DOC-ADHAR",
//       label: "Aadhaar",
//       source: "DigiLocker",
//       status: "Verified", // Verified | Pending | Rejected
//       maskedId: "xxxx-xxxx-1234",
//     },
//     {
//       id: "DOC-PAN",
//       label: "PAN Card",
//       source: "DigiLocker",
//       status: "Verified",
//       maskedId: "ABCDE1234X",
//     },
//     {
//       id: "DOC-CANCELLED-CHQ",
//       label: "Cancelled Cheque",
//       source: "Upload",
//       status: "Pending",
//       maskedId: "A/C ****4321",
//     },
//   ],
// };

// // Simple financial ledger for the retailer: invoices, payments, credit notes, settlements
// const mockLedgerEntries = [
//   {
//     id: 1,
//     date: "2025-10-02",
//     type: "Invoice", // Invoice | Payment | Credit Note | Warranty Settlement
//     ref: "INV-2025-001",
//     description: "Invoice raised",
//     debit: 25000,
//     credit: 0,
//   },
//   {
//     id: 2,
//     date: "2025-10-05",
//     type: "Payment",
//     ref: "PAY-7781",
//     description: "Payment received via UPI",
//     debit: 0,
//     credit: 25000,
//   },
//   {
//     id: 3,
//     date: "2025-10-10",
//     type: "Invoice",
//     ref: "INV-2025-002",
//     description: "Invoice raised",
//     debit: 40000,
//     credit: 0,
//   },
//   {
//     id: 4,
//     date: "2025-10-15",
//     type: "Credit Note",
//     ref: "CN-9001",
//     description: "Rate difference adjustment",
//     debit: 0,
//     credit: 5000,
//   },
//   {
//     id: 5,
//     date: "2025-10-25",
//     type: "Warranty Settlement",
//     ref: "WAR-1001",
//     description: "Warranty claim settled",
//     debit: 0,
//     credit: 5000,
//   },
//   {
//     id: 6,
//     date: "2025-11-02",
//     type: "Invoice",
//     ref: "INV-2025-004",
//     description: "Invoice raised",
//     debit: 50000,
//     credit: 0,
//   },
//   {
//     id: 7,
//     date: "2025-11-10",
//     type: "Payment",
//     ref: "PAY-8892",
//     description: "Weekly combined payout",
//     debit: 0,
//     credit: 45000,
//   },
// ];

// // Users under the retailer login
// // const mockUsers = [
// //   {
// //     id: 1,
// //     name: "Owner (Primary)",
// //     role: "Admin",
// //     mobile: "+91 98765 00001",
// //     email: "owner@retailer.com",
// //     status: "Active", // Active | Inactive | Blocked
// //     lastLogin: "2025-11-10 14:23",
// //   },
// //   {
// //     id: 2,
// //     name: "Billing Desk",
// //     role: "Finance",
// //     mobile: "+91 98765 00002",
// //     email: "billing@retailer.com",
// //     status: "Active",
// //     lastLogin: "2025-11-12 11:05",
// //   },
// //   {
// //     id: 3,
// //     name: "Service Head",
// //     role: "Warranty",
// //     mobile: "+91 98765 00003",
// //     email: "service@retailer.com",
// //     status: "Inactive",
// //     lastLogin: "2025-09-02 09:15",
// //   },
// // ];

// function RetailerDashboard() {
//   // const [salesWarranty] = useState(mockSalesAndWarranty);
//   // const [invoices] = useState(mockInvoices);
//   // const [warrantyClaims] = useState(mockWarrantyClaims);
//   // const [soldWarranties] = useState(mockSoldWarranties);
//   // const [documents] = useState(mockDocuments);
//   // const [ledgerEntries] = useState(mockLedgerEntries);
//   // const [users] = useState(mockUsers);

//   const navigate = useNavigate();

//   const [currentView, setCurrentView] = useState("dashboard"); // dashboard | warranty | invoices | documents | ledger | users
//   const [warrantyFilter, setWarrantyFilter] = useState("all");

//   // const warrantyStats = useMemo(() => {
//   //   const total = salesWarranty.totalWarrantySubmitted || 0;
//   //   const approved = salesWarranty.totalWarrantyApproved || 0;
//   //   const rejected = salesWarranty.totalWarrantyRejected || 0;
//   //   const pending = salesWarranty.totalWarrantyPending || 0;

//   //   const approvalRate = total ? Math.round((approved / total) * 100) : 0;
//   //   const rejectRate = total ? Math.round((rejected / total) * 100) : 0;

//   //   return { total, approved, rejected, pending, approvalRate, rejectRate };
//   // }, [salesWarranty]);

//   // const moneyStats = useMemo(() => {
//   //   const payable = salesWarranty.payableAmount || 0;
//   //   const paid = salesWarranty.paidAmount || 0;
//   //   const earnings = salesWarranty.earningsAmount || 0;
//   //   const pendingPayment = payable - paid;

//   //   return { payable, paid, earnings, pendingPayment };
//   // }, [salesWarranty]);

//   // const filteredWarrantyClaims = useMemo(() => {
//   //   if (warrantyFilter === "all") return warrantyClaims;
//   //   return warrantyClaims.filter((w) => w.status === warrantyFilter);
//   // }, [warrantyClaims, warrantyFilter]);

//   // const sidebarItems = [
//   //   { id: "dashboard", label: "Overview", icon: LayoutDashboard },
//   //   { id: "warranty", label: "Warranty", icon: ShieldCheck },
//   //   { id: "invoices", label: "Invoices & Payments", icon: FileSpreadsheet },
//   //   { id: "ledger", label: "Ledger", icon: Scale },
//   //   { id: "users", label: "Users & Access", icon: UsersIcon },
//   //   { id: "documents", label: "Legal & KYC", icon: FileText },
//   // ];


//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   const LoginUserName = authUser?.business_name;
//   const loginUserCode = authUser?.org_code;

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/login");
//   };

//   return (
//       <div className="flex-1 flex flex-col">

//         {/* Main Body */}
//         <main className="flex-1 space-y-4">
//           {currentView === "dashboard" && (
//             <>
//             {/* <DashboardView
//               salesWarranty={salesWarranty}
//               warrantyStats={warrantyStats}
//               moneyStats={moneyStats}
//               warrantyTrend={warrantyTrend}
//               invoiceTrend={invoiceTrend}
//             /> */}
//             <CompanySales/>
//             </>
//           )}

//           {/* {currentView === "warranty" && (
//             <WarrantyView
//               soldWarranties={soldWarranties}
//               warrantyClaims={filteredWarrantyClaims}
//               warrantyFilter={warrantyFilter}
//               setWarrantyFilter={setWarrantyFilter}
//             />
//           )} */}

//           {/* {currentView === "invoices" && (
//             <InvoicesView invoices={invoices} moneyStats={moneyStats} />
//           )} */}

//           {/* {currentView === "ledger" && <LedgerView ledgerEntries={ledgerEntries} />} */}

//           {/* {currentView === "users" && <UsersView users={users} />} */}

//           {/* {currentView === "documents" && <DocumentsView documents={documents} />} */}
//         </main>
//       </div>
    
//   );
// }


// export default RetailerDashboard;
